import { queryKeys } from "../queryKeys";
import { type Account, getLiveAccounts } from "../rest/account";
import useRequest, { doNotRetryOn401, type QueryOptions } from "./useRequest";

export const useGetLiveAccounts = (options?: QueryOptions<Account[]>) => {
  return useRequest<Account[]>(
    queryKeys.accounts.live(),
    () => getLiveAccounts(),
    {
      refetchInterval: false,
      ...options,
      // authoritative: not overridable by caller options
      retry: doNotRetryOn401,
    },
  );
};

export default useGetLiveAccounts;
